// extracted by mini-css-extract-plugin
export default {"base":"ColumnChartDisplay_base__bN6PN","select":"ColumnChartDisplay_select__Mcn5n"};